"use client";

import { useState } from "react";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";

interface CollapsibleProps {
  children: React.ReactNode;
  maxHeight?: number;
  className?: string;
}

export default function Collapsible({ 
  children, 
  maxHeight = 400,
  className = "" 
}: CollapsibleProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={className}>
      <div
        style={{ maxHeight: isExpanded ? 'none' : `${maxHeight}px` }}
        className="relative overflow-hidden transition-all duration-300"
      >
        {children}
        {!isExpanded && (
          <div 
            className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent pointer-events-none" 
            aria-hidden="true"
          />
        )}
      </div>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center gap-1 mt-2 text-blue-600 hover:text-blue-700 transition-colors"
      >
        {isExpanded ? (
          <>
            <IconChevronUp size={20} />
            <span>Show less</span>
          </>
        ) : (
          <>
            <IconChevronDown size={20} />
            <span>Show more</span>
          </>
        )}
      </button>
    </div>
  );
} 